import { TENANT_IDS } from "../constants/tenantIds";

type FixedTenant = { id: string; name: string };

export type WastePipelineFileSlot = {
  /** Unique key used to map files end-to-end (registry → S3 → local path → pipeline run) */
  key: string;
  /** Display label shown on the UI upload button */
  label: string;
  /** HTML accept attribute for the file input (e.g. ".xlsx,.xls,.csv") */
  accept: string;
  /** Whether this file must be provided to dispatch the pipeline */
  required: boolean;
};

export type WastePipelineConfig = {
  /** Display label for UI dropdown */
  label: string;
  /** File upload slots — each slot becomes a separate upload in the UI */
  files: WastePipelineFileSlot[];
  /** If set, pipeline is locked to this tenant (skips org picker in UI) */
  fixedTenant: FixedTenant | null;
};

export const WASTE_PIPELINE_REGISTRY = {
  "amazon-clean-earth": {
    label: "Amazon Clean Earth",
    files: [
      {
        key: "source",
        label: "CE Monthly Reporting Package",
        accept: ".xlsx,.xls",
        required: true,
      },
      {
        key: "receivingFacilities",
        label: "CE Receiving Facilities",
        accept: ".xlsx,.xls,.csv",
        required: true,
      },
    ],
    fixedTenant: { id: TENANT_IDS.AMAZON, name: "Amazon" },
  },
  "amazon-clean-harbors": {
    label: "Amazon Clean Harbors",
    files: [
      { key: "biennial", label: "Biennial Data", accept: ".xlsx,.xls", required: true },
      { key: "monthly", label: "Monthly Data (Optional)", accept: ".xlsx,.xls", required: false },
    ],
    fixedTenant: { id: TENANT_IDS.AMAZON, name: "Amazon" },
  },
  "clean-harbors": {
    label: "Clean Harbors",
    files: [{ key: "source", label: "Clean Harbors Excel", accept: ".xlsx,.xls", required: true }],
    fixedTenant: null,
  },
} as const satisfies Record<string, WastePipelineConfig>;

export type WastePipelineName = keyof typeof WASTE_PIPELINE_REGISTRY;

export function isWastePipelineName(name: string): name is WastePipelineName {
  return name in WASTE_PIPELINE_REGISTRY;
}

export const WASTE_PIPELINE_NAMES =
  Object.keys(WASTE_PIPELINE_REGISTRY).filter(isWastePipelineName);
